import React from "react";

const sizes = {
  headings_h3: "font-dmsans text-[24px] font-bold md:text-[22px]",
  text6xl: "text-[19px] font-medium",
  text7xl: "text-[20px] font-medium",
  text12xl: "text-[36px] font-medium md:text-[34px] sm:text-[21px]",
  text13xl: "text-[46px] font-medium md:text-[42px] sm:text-[24px]",
  headingxs: "text-[13px] font-bold",
  headings: "text-[15px] font-bold",
  headingmd: "text-[16px] font-bold",
  headinglg: "text-[17px] font-bold",
  headingxl: "text-[18px] font-bold",
  heading2xl: "text-[19px] font-bold",
  heading3xl: "text-[20px] font-bold",
  heading4xl: "text-[21px] font-bold",
  heading5xl: "text-[22px] font-bold",
  heading6xl: "text-[23px] font-bold md:text-[21px]",
  heading7xl: "text-[24px] font-bold md:text-[22px] sm:text-[16px]",
  heading8xl: "text-[25px] font-bold md:text-[23px] sm:text-[17px]",
  heading9xl: "text-[26px] font-bold md:text-[24px] sm:text-[18px]",
  heading10xl: "text-[30px] font-bold md:text-[28px] sm:text-[19px]",
  heading11xl: "text-[32px] font-bold md:text-[30px] sm:text-[20px]",
  heading12xl: "text-[35px] font-bold md:text-[33px] sm:text-[21px]",
  heading13xl: "text-[37px] font-bold md:text-[35px] sm:text-[22px]",
  heading14xl: "text-[38px] font-black md:text-[36px] sm:text-[23px]",
  heading15xl: "text-[46px] font-bold md:text-[42px] sm:text-[24px]",
  heading16xl: "text-[56px] font-bold md:text-[48px] sm:text-[25px]",
  heading17xl: "text-[62px] font-bold md:text-[48px] sm:text-[25px]",
  heading18xl: "text-[64px] font-bold md:text-[48px] sm:text-[25px]",
  heading19xl: "text-[74px] font-bold md:text-[48px] sm:text-[25px]",
};

const Heading = ({ children, className = "", size = "heading15xl", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component
      className={`font-spacegrotesk ${className} ${sizes[size]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Heading };
